module.exports = __webpack_public_path__ + "static/media/miniinfinity2.bcc83d4d.jpg";